import React from 'react';
import { convertToThousands, percentageValue, splitByThousands } from '../../helpers/NumberFormatter';

export default function AbsoluteValue(props) {
    const { value, convert, isWithNote = false } = props;
    return <span title={splitByThousands(value)} className={props.className}>
        {convertToThousands(value)}{isWithNote && "*"}  
    </span>    
}
